import { DEFAULT_CONFIG } from './config';

export async function login(wax) {
  try {
    await wax.login();
    return wax;
  } catch(e) {
    console.log(e.message)
  }
};

export async function sign(wax, publicKey, signature, setCongrats, setIsValid, setErrorMessage) {
  try {
    await wax.api.transact({
      actions: [{
        account: DEFAULT_CONFIG.account,
        name: DEFAULT_CONFIG.name,
        authorization: [{
          actor: wax.userAccount,
          permission: 'active',
        }],
        data: {
          claimer: wax.userAccount,
          drop_id: DEFAULT_CONFIG.drop_id,
          claim_amount: 1,
          intended_delphi_median: 0,
          authkey_key: publicKey,
          signature_nonce: DEFAULT_CONFIG.nonce,
          claim_signature: signature,
          referrer: 'test',
          country: 'USA'
        },
      }]
    }, {
      blocksBehind: 3,
      expireSeconds: 30
    });
    setCongrats(true)
  } catch(e) {
    setIsValid(false)
    setErrorMessage(e.message)
  }
};